<template>
  <div class="resultados">
    <table>
      <thead>
        <tr>
          <th class>LEGISLAÇÃO</th>
          <th>DIÁRIO OFICIAL DE PUBLICAÇÃO</th>
          <th>DATA DA LEGISLAÇÃO</th>
          <th>SITUAÇÃO</th>
          <th>TEXTO</th>
          <th>EMENTA</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(legislacao, index) in legislacoesOrdenadas">
          <tr :key="legislacao.id">
            <td class="topo-card">
              <router-link
                :to="getLegislacaoRoute(legislacao)"
                target="_blank"
              >
                <span>{{ tipoLegislacao(legislacao) }}<br>Nº {{ legislacao.numero }} / {{ legislacao.ano }}</span>
              </router-link>
            </td>
            <td data-label="Diário Oficial de Publicação:" class="publi-do">
              <div v-for="diario in legislacao.diarios" :key="diario.numero">
                <a
                  :href="diario.link_download"
                  target="_blank"
                  v-if="diario.link_download"
                >
                  {{ descricaoDiario(diario) }}
                  <span v-if="diario.suplemento == 'Sim'">Suplemento</span>
                </a>
                <p v-else>
                  {{ descricaoDiario(diario) }}
                  <span v-if="diario.suplemento == 'Sim'">Suplemento</span>
                </p>
              </div>
            </td>
            <td data-label="Data da Legislação: ">
              {{ formatarDataLegislacao(legislacao.data_legislacao) }}
            </td>
            <td data-label="Situação">
              {{
                legislacao.estado_legislacao
                  ? legislacao.estado_legislacao.nome
                  : ""
              }}
            </td>
            <td data-label="Texto:">
              <router-link
                :to="getLegislacaoRoute(legislacao)"
                target="_blank"
              >
                <img
                  src="../../assets/images/icon_text.svg"
                  class="icon-txt t-preto"
                  alt="Acessar Texto"
                  title="Acessar texto"
                />
                <img
                  src="../../assets/images/icon_text_bco.svg"
                  class="icon-txt t-branco"
                  alt="Acessar Texto"
                  title="Acessar texto"
                />
              </router-link>
              <a @click="registra_GA4(legislacao)" :href="urlPdf(legislacao)" target="_blank">
                <img
                  src="../../assets/images/icon_pdf.svg"
                  class="icon-pdf"
                  alt="Abrir texto em pdf"
                  title="Abrir texto em PDF"
                />
              </a>
            </td>
            <td data-label="Ementa:">
              {{ truncateString(legislacao.ementa, 150) }}
            </td>
            <td class="botao">
              <button v-if="exibirBotao(legislacao)" @click="exibir(index)">
                {{ exibirMais[index] ? "ocultar" : "ver mais" }}
              </button>
            </td>
          </tr>
          <tr
            :key="`${legislacao.id}mais`"
            v-show="exibirMais[index]"
            class="exibir-mais"
          >
            <td colspan="7">
              <DetalhesLegislacao :legislacao="legislacao"></DetalhesLegislacao>
            </td>
          </tr>
        </template>
        <tr
          v-if="!legislacoes || legislacoes.length == 0"
          class="sem-resultados"
        >
          <td :colspan="isMunicipal ? 8 : 7">Nenhum resultado encontrado</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DetalhesLegislacao from "./DetalhesLegislacao";
import truncateString from "../../helpers/truncateString";
import registraEventoGoogleAnalytics from "../../helpers/registraEventoGoogleAnalytics";

export default {
  name: "TabelaResultadosLegislacao",
  props: {
    legislacoes: Array,
    isMunicipal: {
      type: Boolean,
      default: false,
    },
    municipioSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      exibirMais: {},
    };
  },
  computed: {
    legislacoesOrdenadas() {
      if (!this.legislacoes) return [];

      // A ordenação agora vem sempre do backend
      return this.legislacoes;
    },
  },
  components: {
    DetalhesLegislacao,
  },
  watch: {
    legislacoes: function () {
      this.exibirMais = {};
    },
  },
  methods: {
    exibir: function (index) {
      this.$set(this.exibirMais, index, !this.exibirMais[index]);
    },
    exibirBotao: function (legislacao) {
      return (
        legislacao.autor ||
        legislacao.numero_processo_projeto_lei ||
        (legislacao.projeto_legislacao &&
          (legislacao.projeto_legislacao.numero_autografo_lei ||
            legislacao.projeto_legislacao.processo_sei_autografo ||
            legislacao.projeto_legislacao.numero_oficio_msg ||
            legislacao.projeto_legislacao.processo_sei_oficio_msg ||
            legislacao.projeto_legislacao.numero_oficio_veto ||
            legislacao.projeto_legislacao.processo_sei_veto ||
            legislacao.projeto_legislacao.numero_oficio_derrubada_veto)) ||
        (legislacao.categorias_legislacoes &&
          legislacao.categorias_legislacoes.length) ||
        (legislacao.orgaos && legislacao.orgaos.length > 0) ||
        (legislacao.modificada_por_legislacoes &&
          legislacao.modificada_por_legislacoes.length > 0) ||
        (legislacao.legislacoes_que_altera &&
          legislacao.legislacoes_que_altera.length > 0) ||
        (legislacao.mensagens_veto && legislacao.mensagens_veto.length > 0)
      );
    },
    tipoLegislacao: function (legislacao) {
      if (legislacao && legislacao.tipo_legislacao) {
        return legislacao.tipo_legislacao.nome;
      }
      return "";
    },
    nomeLegislacao: function (legislacao) {
      if (legislacao) {
        return `Nº ${legislacao.numero} / ${legislacao.ano}`;
      }
      return "";
    },
    descricaoDiario: function (diario) {
      if (diario) {
        let result = "";
        if (diario.numero) {
          result += `Nº ${diario.numero}`;
        }
        const data = diario.data_diario || diario.data;
        if (data) {
          if (result.length > 0) {
            result += " - ";
          }
          result += `${data}`;
        }
        return result;
      }
      return "";
    },
    urlPdf: function (legislacao) {
      if (this.isMunicipal && this.municipioSlug) {
        return `${process.env.VUE_APP_BASE_API_URL}/api/v2/${this.municipioSlug}/pesquisa/legislacoes/${legislacao.id}/pdf`;
      }
      return `${process.env.VUE_APP_BASE_API_URL}/api/v2/pesquisa/legislacoes/${legislacao.id}/pdf`;
    },
    truncateString,
    registra_GA4(legislacao) {
      registraEventoGoogleAnalytics(
        this.$gtag,
        'visualizacao_pdf_legislacao',
        'download_pdf_legislacao',
        'PDF - ' + this.tipoLegislacao(legislacao) + ' ' + this.nomeLegislacao(legislacao)
      )
    },
    getLegislacaoRoute(legislacao) {
      if (this.isMunicipal && this.municipioSlug) {
        return {
          name: 'PesquisaLegislacaoMunicipalShow',
          params: {
            slug: this.municipioSlug,
            id: legislacao.id
          }
        };
      } else {
        return {
          name: 'PesquisaLegislacaoShow',
          params: { id: legislacao.id }
        };
      }
    },
    formatarDataLegislacao(dataString) {
      if (!dataString) return '';

      // Se a data já está no formato DD/MM/YYYY, retorna como está
      if (dataString.includes('/')) return dataString;

      // Converte YYYY-MM-DD para DD/MM/YYYY
      const partes = dataString.split('-');
      if (partes.length === 3) {
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
      }

      return dataString;
    },
    parseDataLegislacao(dataString) {
      if (!dataString) return null;

      // Formato DD/MM/YYYY
      if (dataString.includes('/')) {
        const partes = dataString.split('/');
        if (partes.length === 3) {
          const dia = parseInt(partes[0], 10);
          const mes = parseInt(partes[1], 10) - 1;
          const ano = parseInt(partes[2], 10);
          const data = new Date(ano, mes, dia);
          return isNaN(data.getTime()) ? null : data;
        }
      }

      // Formato YYYY-MM-DD
      if (dataString.includes('-')) {
        const partes = dataString.split('-');
        if (partes.length === 3) {
          const ano = parseInt(partes[0], 10);
          const mes = parseInt(partes[1], 10) - 1;
          const dia = parseInt(partes[2], 10);
          const data = new Date(ano, mes, dia);
          return isNaN(data.getTime()) ? null : data;
        }
      }

      const data = new Date(dataString);
      return isNaN(data.getTime()) ? null : data;
    }
  },
};
</script>

<style lang="scss" scoped>
.resultados {
  table {
    // border-collapse: collapse;
    width: 100%;
    a {
      cursor: pointer;
      color: #115810;
    }
    thead {
      border-bottom: solid #ffa900 0.15rem;
      color: #0a4a22;
      font-family: "poppins-bold";
      th {
        padding: 0rem 2rem;
      }
      th:nth-child(1) {
        text-align: left;
        padding-left: 0.5rem;
      }
    }
    tbody {
      tr {
        margin: 1rem;
        td {
          color: #083e07;
          padding: 0.5rem;
        }
        td:nth-child(1) {
          min-width: 12rem;
        }
        td:nth-child(2) {
          text-align: center;
        }
        td:nth-child(3) {
          text-align: center;
        }
        td:nth-child(4) {
          text-align: center;
        }
        td:nth-child(5) {
          text-align: center;
          max-width: 50rem;
        }
      }
      tr:nth-child(4n + 1),
      tr:nth-child(4n + 2) {
        // background-color: #edf2ee;
      }
      .sem-resultados {
        background-color: transparent !important;
        text-align: center;
        height: 5rem;
        color: rgb(73, 73, 73);
        font-style: oblique;
      }
    }
    .botao {
      width: 7rem;
      padding-bottom: 1rem;
      text-align: center;
      margin-top: 1rem;
      button {
        background-color: transparent;
        font-family: "Poppins";
        color: #0a4a22;
        border: #0a4a22 solid 0.15rem;
        border-radius: 0.2rem;
        padding: 0rem 1rem;
        font-size: 1rem;
        cursor: pointer;
      }
    }
  }
  td {
    img {
      height: 1.5rem;
      margin: 0rem 0.5rem 0rem 0.5rem;
    }
    .t-branco {
      display: none;
    }
  }
}
.alto-contraste {
  table {
    thead {
      th {
        color: #ffa900;
      }
    }
    tbody {
      color: #083e07;
      tr {
        margin: 1rem;
        td {
          color: white;
        }
      }
      tr:nth-child(4n + 1),
      tr:nth-child(4n + 2) {
        background-color: #202020;
      }
      .sem-resultados {
        color: white !important;
      }
      a {
        color: rgb(0, 169, 211);
      }
    }
    .botao {
      button {
        color: #ffa900;
        border: #ffa900 solid 0.15rem;
      }
    }
  }
  td {
    .t-preto {
      display: none;
    }
    .t-branco {
      display: inline;
    }
  }
}
@media screen and (max-width: 64rem) {
  .resultados {
    table {
      width: calc(100% - 2rem);
      tbody {
        background-color: transparent;
      }
      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }

      tr {
        margin: 1rem;
        display: block;
        margin-bottom: 1em;
        background-color: #edf2ee;
        padding-bottom: 1rem;
        width: 100% !important;
        td {
          padding: 0rem !important;
          min-height: 1.94rem;
        }
        td:nth-child(2) {
          text-align: left !important;
        }
        td:nth-child(3) {
          text-align: left !important;
        }
        td:nth-child(4) {
          text-align: left !important;
        }
        td:nth-child(5) {
          text-align: left !important;
          max-width: 50rem;
        }
        .acao {
          display: none;
        }
      }
      tr:nth-child(even) td {
        display: block;
        margin-bottom: 0.5em;
        background-color: transparent !important;
      }
      .sem-resultados {
        padding-top: 5rem;
      }
      td {
        display: block;
        min-height: 1.3rem;
        margin: 0.3rem 0.5rem;
        font-size: 0.9rem;
        img {
          height: 1.5rem;
          margin: 0rem 1rem;
        }
      }

      td::before {
        content: attr(data-label);
        float: left;
        font-weight: bold;
        color: #0a4a22;
        font-family: "Poppins-Medium";
        margin-right: 0.5rem;
      }
      .topo-card {
        background-color: #115810;
        font-family: "Poppins";
        text-align: center;
        margin: 0rem 0rem 1rem 0rem;
        font-weight: 600 !important;
        padding: 0.5rem 0rem !important;
        font-size: 0.9rem;
        a {
          color: white;
          text-decoration: none;
        }
      }
      .botao {
        padding-bottom: 1rem;
        text-align: center;
        margin-top: 1rem;
        margin-left: -0.25rem;
        width: 100%;
        button {
          background-color: transparent;
          font-family: "Poppins";
          color: #0a4a22;
          border: #0a4a22 solid 0.1rem;
          border-radius: 0.2rem;
          padding: 0.1rem 1.5rem;
          font-size: 0.9rem;
        }
      }
      .exibir-mais {
        margin-top: -1rem;
        color: black;
        text-align: left;
      }
    }
  }
  .alto-contraste {
    .resultados {
      table {
        tr {
          background-color: #202020;
        }
        td::before {
          color: #c2c2c2;
        }
        .botao {
          button {
            color: #ffa900;
            border: #ffa900 solid 0.15rem;
          }
        }
      }
    }
  }
}
</style>
